/* eslint-disable no-restricted-syntax */
import { IStoreState } from 'store';
import { statusColorDefault } from 'store/field-options/status-colors';

// takes a status (e.g., "other" or "current")
// returns the status' color (string) if it exists
export const getDealStatusIndicatorColor = (state: IStoreState, name: string): string => {
  const { fieldOptions } = state;
  const { statuses } = fieldOptions;

  let returnValue = statusColorDefault;
  if (!statuses) {
    return returnValue;
  }

  for (const status of statuses) {
    if (status.name === name) {
      returnValue = status.color;
      break;
    }
  }

  return returnValue;
};
